import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .whats-new-inner-page-side-by-side-text-and-asset-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    .back-to-releases {
      color: black;
      text-decoration: none;
    }
    .side-by-side-text-and-asset-component {
      padding-top: 32px;
      .side-by-side-text-and-asset .side-by-side-content {
        padding-top: 20px;
        align-items: flex-start;
        .full-paragraph-component-wrapper {
          .right-section {
            .right-section-content {
              .tags {
                display: flex;
                flex-direction: row;
                gap: 10px;
                margin-bottom: 16px;
              }
              .date {
                margin-top: 24px;
              }
              .share-post-section {
                margin-top: 24px;
              }
            }
          }
        }
      }
    }
  }
`;
